import React, { Component } from "react";
import styled from "styled-components";
import NanoFlex from "../Global/NanoFlex.js";

const StyledMenuBurguer = styled(NanoFlex)`
  width: auto;
  height: auto;

  .menuMobile {
    width: 36px;
    height: 36px;
    padding: 0;
    margin: 0;
    outline: none;
    position: relative;
    border: none;
    background: none;
    transform: scale(0.6);
    cursor: pointer;
    right: -7px;

    @media only screen and (max-width: 390px) {
      right: 6px;
    }

    svg {
      width: 64px;
      height: 48px;
      top: -6px;
      left: -14px;
      stroke: ${(props) => props.theme.color.primaryColors.darkPurple};
      stroke-width: 4px;
      stroke-linecap: round;
      stroke-linejoin: round;
      fill: none;
      display: block;
      position: absolute;

      @media only screen and (max-width: 390px) {
        left: 10px;
      }

      path {
        transition: stroke-dasharray var(--duration, 0.85s) var(--easing, ease) var(--delay, 0s), stroke-dashoffset var(--duration, 0.85s) var(--easing, ease) var(--delay, 0s);
        stroke-dasharray: var(--array-1, 26px) var(--array-2, 100px);
        stroke-dashoffset: var(--offset, 126px);
        transform: translateZ(0);
        &:nth-child(2) {
          --duration: 0.4s;
          --easing: ease-in-out;
          --offset: 100px;
          --array-2: 74px;
        }
        &:nth-child(3) {
          --offset: 133px;
          --array-2: 107px;
        }
      }
    }

    &.openMenu {
      svg {
        stroke: ${(props) => props.theme.color.primaryColors.lighterYellow};
        path {
          --offset: 57px;
          &:nth-child(1),
          &:nth-child(3) {
            --delay: 0.15s;
            --easing: cubic-bezier(0.2, 0.4, 0.2, 1.1);
          }
          &:nth-child(2) {
            --duration: 0.4s;
            --offset: 2px;
            --array-1: 1px;
          }
          &:nth-child(3) {
            --offset: 58px;
          }
        }
      }
    }
  }
`;

class MenuBurguer extends Component {
  constructor() {
    super();

    this.state = {
      open: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.open !== this.state.open && this.props.onOpenChange) this.props.onOpenChange(this.state.open);

    if (this.props.open !== prevProps.open && this.props.open !== this.state.open) {
      this.setState({ open: this.props.open });
    }
  }

  onOpenClick = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    return (
      <StyledMenuBurguer>
        <NanoFlex className={`menuMobile ${this.state.open ? "openMenu" : ""}`} flexDirection="column" justifyContent="space-between" onClick={() => this.onOpenClick()}>
          <svg viewBox="0 0 64 48">
            <path d="M19,15 L45,15 C70,15 58,-2 49.0177126,7 L19,37"></path>
            <path d="M19,24 L45,24 C61.2371586,24 57,49 41,33 L32,24"></path>
            <path d="M45,33 L19,33 C-8,33 6,-2 22,14 L45,37"></path>
          </svg>
        </NanoFlex>
      </StyledMenuBurguer>
    );
  }
}

export default MenuBurguer;

// --- // Documentation // --- //
/*
  import MenuBurguer from './Animations/MenuBurguer.js';
  
  <MenuBurguer />
  */
